import router from "@/router";

export function pushWithQuery(name: any) {
  router.push({
    name,
    query: {
      ...router.currentRoute.value.query,
    },
  });
}

export function redirectToLoginPage() {
  router.push({
    name: "login",
    query: {
      ...router.currentRoute.value.query,
    },
  });
}
